export {
  convertRelObjectToString,
  convertRelStringToObject,
  convertTargetBooleanToString,
  convertTargetStringToBoolean,
  getRelValue,
} from '../Utils/linkConverters.js';
